export function analyticsEvent(data, useAnalyticService) {
    switch (data.analyticsFct) {
        case 'trackEvent':
            useAnalyticService?.().trackEvent(data.eventName, data.payload);
            break;
        case 'resetEcommerce':
            useAnalyticService?.().resetEcommerce();
            break;
        case 'flushStoredEvents':
            useAnalyticService?.().flushStoredEvents();
            break;
    }
}
//# sourceMappingURL=analytics.js.map